import ModalCompetitors, {
  MODAL_COMPETITORS_FROM_MENU,
} from "../Modal/ModalCompetitors";
import useOutsideCampaignGallery from "../../hooks/useOutsideCampaignGallery";
import ModalCreateWithIA from "../Modal/ModalCreateWithIA";

const CompetitorScopeFlowModals = ({
  isCompetitorsModalOpen,
  onCloseCompetitorsModal,
  onCompetitorAdsSelected,
  isCreateWithIAOpen,
  onCloseCreateWithIA,
  createWithIAKey,
  createWithIAInitialValues,
  onCallbackAfterSaveToGallery: onCallbackAfterSaveToGalleryFromParent,
}) => {
  const internalGallery = useOutsideCampaignGallery();
  const onCallbackAfterSaveToGallery =
    onCallbackAfterSaveToGalleryFromParent ?? internalGallery.onOpenGallery;

  return (
    <>
      {isCompetitorsModalOpen ? (
        <ModalCompetitors
          modalOpen={isCompetitorsModalOpen}
          onCloseModal={onCloseCompetitorsModal}
          from={MODAL_COMPETITORS_FROM_MENU}
          onCallbackSelectedItems={onCompetitorAdsSelected}
        />
      ) : null}

      {isCreateWithIAOpen ? (
        <ModalCreateWithIA
          key={createWithIAKey}
          modalOpen={isCreateWithIAOpen}
          onCloseModal={onCloseCreateWithIA}
          initialValues={createWithIAInitialValues}
          onCallbackAfterSaveToGallery={onCallbackAfterSaveToGallery}
        />
      ) : null}

      {onCallbackAfterSaveToGalleryFromParent
        ? null
        : internalGallery.galleryModal}
    </>
  );
};

export default CompetitorScopeFlowModals;
